import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'checkSmall',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-check-small wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="m10.34 14.043 5.101-5.936a.287.287 0 0 1 .432-.017l.974.827a.344.344 0 0 1 .03.463l-6.13 7.237a.285.285 0 0 1-.407.04l-3.237-2.614a.344.344 0 0 1-.021-.469l.853-1.03a.296.296 0 0 1 .436-.026z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-check-small.svg',
    category: 'Core',
    tags: ['success', 'complete', 'check mark', 'check box'],
};
export default icon;
